import * as endpoints from '@App/constants/endpoints';
import interceptor from '../interceptor';
import axiosRef from 'axios';
import * as util from '@Util/';
import { get } from '../util';
import { post } from '../util';
import { put } from '../util';
import { patch } from '../util';
import { del } from '../util';

const ANSWERS = 'answers';
const FORM = 'form';
const MODEL = 'model';
const VERSION = 'version';
const EMPTY = 'empty';
const DRAFT = 'draft';
const NAME = 'name';
const AVAILABILITY = 'availability';
const ACCOUNT = 'account';
const WORKSPACE = 'workspace';
const PRINT_FORMAT = 'printFormat';
const GLOBALS = 'globals';
const PATIENT = 'patient';
const ANSWER = 'answer';
const ATTENDANCE = 'attendance';
const FIELD_MARK = 'fieldMark';
const FORM_CONFIG = 'formConfig';
const STATUS = 'status';
const LAST_VERSION = 'last-version';
const UPLOAD = 'upload';
const DOCUMENT = 'document';
const EXTRACT = 'extract';
const TEXT = 'text';

//#region GET
export const getFormModels = async ({ header, isAccountForm = 0, listType = 'active' }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}?isAccountForm=${isAccountForm}&listType=${listType}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const getFormGlobals = async ({ header }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${GLOBALS}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const getFormAnswers = async ({ header, formModelId }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${formModelId}/${ANSWERS}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const getFormModelVersionById = async ({
  header,
  formModelVersionId,
}) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${VERSION}/${formModelVersionId}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const getFormById = async ({ header, formId }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${formId}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const getFormAnswerPatientById = async ({ header, formId }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${formId}/${ANSWER}/${PATIENT}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const getFormPrintFormat = async ({ header, formId }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${formId}/${PRINT_FORMAT}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const getAttendancePrintFormat = async ({ header, medicalRecordsAttendanceId }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${medicalRecordsAttendanceId}/${ATTENDANCE}/${PRINT_FORMAT}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const getFormModelByIdAnswer = async ({ header, formModelId }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${formModelId}/${ANSWERS}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const getFormListAnswers = async ({ header }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const getDrafts = async ({ header, isAccountForm = 0, listType = 'active' }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${DRAFT}/?isAccountForm=${isAccountForm}&listType=${listType}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const getDraftById = async ({ header, draftId }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${DRAFT}/${draftId}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const checkNameFormModel = async ({ header, nameForm }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${NAME}/${AVAILABILITY}/${nameForm}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const checkNameAccountFormModel = async ({ header, nameForm }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${NAME}/${ACCOUNT}/${AVAILABILITY}/${nameForm}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const getFormConfig = async ({ header, params }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM_CONFIG}/${PATIENT}/${ACCOUNT}?formModelId=${params.formModelId}&patientId=${params.patientId}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const getFormModelVersionLastVersion = async ({ header, formModelId }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${formModelId}/${LAST_VERSION}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};
//#endregion

//#region POST
export const createFormEmpty = async ({ header, formModelVersionId }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${EMPTY}/${formModelVersionId}`;
  const axios = interceptor(header);
  return await post(axios, pathUrl);
};

export const createFormEmptyBatch = async ({ header, formModelVersionId, medicalRecordsAttendanceIds }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${EMPTY}/${formModelVersionId}/batch`;
  const axios = interceptor(header);
  return await post(axios, pathUrl, { medicalRecordsAttendanceIds });
};

export const createFormEmptyAttendanceAnswer = async ({ header, formModelVersionId, params }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${EMPTY}/${PATIENT}/${ANSWER}/${formModelVersionId}`;
  const axios = interceptor(header);
  return await post(axios, pathUrl, params);
};

export const saveForm = async ({ header, params }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}`;
  const axios = interceptor(header);
  return await post(axios, pathUrl, params);
};

export const createAnsweredForm = async ({ header, params }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}`;
  const axios = interceptor(header);
  return await post(axios, pathUrl, params);
};

export const postDraft = async ({ header, params }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${DRAFT}`;
  const axios = interceptor(header);
  return await post(axios, pathUrl, params);
};

export const uploadDocumentForExtraction = async ({ header, params, onUploadProgress }) => {
  const { file } = params;
  const formData = new FormData();
  formData.append('pdf', file);

  const pathUrl = `${endpoints.API_FORMS}/ai/proms/analyze-pdf`;
  const axios = interceptor({
    ...header,
    'Content-Type': 'multipart/form-data'
  });

  const config = {
    onUploadProgress: onUploadProgress || null
  };

  return await post(axios, pathUrl, formData, config);
};

export const extractTextFromDocument = async ({ header, params }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${EXTRACT}/${TEXT}`;
  const axios = interceptor(header);
  return await post(axios, pathUrl, params);
};

/**
 * @param {string} jobId - ID do job
 * @param {object} header - Objeto com token, account, workspace, etc (mesmo formato do interceptor)
 * @param {function} onMessage - Callback para mensagens recebidas (recebe { event, data, timestamp })
 * @param {function} onError - Callback para erros
 * @param {function} onClose - Callback quando conexão for fechada
 * @returns {function} Função para fechar a conexão
 */
export const streamJobProgress = async ({ jobId, header, onMessage, onError, onClose }) => {
  const auth = JSON.parse(util.getCookie('auth') || '{}');

  const wsUrl = endpoints.API_REPORT_GENERATOR_WEBSOCKET;

  try {
    let token = auth?.token || header?.token || '';
    let account = header?.account || header?.accountId || '';
    let workspace = header?.workspace || header?.workspaceId || '';
    let userId = header?.userId || '';
    let formOrigin = header?.formOrigin || '';

    let lang = navigator.language || navigator.userLanguage;
    if (auth && auth.languageCode) {
      lang = auth.languageCode;
    }
    if (lang) {
      lang = lang.startsWith('pt') ? lang : lang.split('-')[0];
    }

    const params = new URLSearchParams();
    params.append('jobId', encodeURIComponent(jobId));
    if (token) params.append('token', encodeURIComponent(`Bearer ${token}`));
    if (account) params.append('account', encodeURIComponent(account));
    if (workspace) params.append('workspace', encodeURIComponent(workspace));
    if (userId) params.append('userId', encodeURIComponent(userId));
    if (formOrigin) params.append('formOrigin', encodeURIComponent(formOrigin));
    if (lang) params.append('lang', encodeURIComponent(lang));

    const url = `${wsUrl}/ws/jobs?${params.toString()}`;

    const ws = new WebSocket(url);

    ws.onmessage = (event) => {
      try {
        const message = JSON.parse(event.data);

        if (message.event !== 'heartbeat' && message.status !== 'heartbeat') {
          onMessage(message);
        }
      } catch (error) {
        console.error('Erro ao parsear mensagem WebSocket:', error);
      }
    };

    ws.onerror = (error) => {
      if (onError) onError(error);
    };

    ws.onclose = () => {
      if (onClose) onClose();
    };

    return () => {
      if (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING) {
        ws.close();
      }
    };

  } catch (error) {
    if (onError) onError(error);
    return () => { };
  }
};

export const streamFormBuilderChat = async ({ sessionId, header, onMessage, onError, onClose }) => {
  const auth = JSON.parse(util.getCookie('auth') || '{}');

  const wsUrl = endpoints.API_REPORT_GENERATOR_WEBSOCKET

  try {
    let token = auth?.token || header?.token || '';
    let account = header?.account || header?.accountId || '';
    let workspace = header?.workspace || header?.workspaceId || '';
    let userId = header?.userId || '';
    let formOrigin = header?.formOrigin || '';

    let lang = navigator.language || navigator.userLanguage;
    if (auth && auth.languageCode) {
      lang = auth.languageCode;
    }
    if (lang) {
      lang = lang.startsWith('pt') ? lang : lang.split('-')[0];
    }

    const params = new URLSearchParams();
    params.append('sessionId', encodeURIComponent(sessionId));
    if (token) params.append('token', encodeURIComponent(`Bearer ${token}`));
    if (account) params.append('account', encodeURIComponent(account));
    if (workspace) params.append('workspace', encodeURIComponent(workspace));
    if (userId) params.append('userId', encodeURIComponent(userId));
    if (formOrigin) params.append('formOrigin', encodeURIComponent(formOrigin));
    if (lang) params.append('lang', encodeURIComponent(lang));


    const url = `${wsUrl}/ws/form-builder?${params.toString()}`;


    const ws = new WebSocket(url);

    ws.onopen = () => {

    };

    ws.onmessage = (event) => {
      try {
        const message = JSON.parse(event.data);

        if (message.event !== 'heartbeat') {
          onMessage(message);
        }
      } catch (error) {
        console.error('Erro ao parsear mensagem WebSocket:', error);
      }
    };

    ws.onerror = (error) => {
      if (onError) onError(error);
    };

    ws.onclose = () => {
      if (onClose) onClose();
    };

    return () => {
      if (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING) {
        ws.close();
      }
    };

  } catch (error) {
    if (onError) onError(error);
    return () => { };
  }
};


let updateAnsweredFormPreviousCall = null; // keeps the last call out of the updateAnsweredForm scope
//#region PUT
export const updateAnsweredForm = async ({ header, params }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}`;
  const axios = interceptor(header);
  const source = axiosRef.CancelToken.source();
  const config = {
    cancelRequest: source.cancel,
    cancelToken: source.token,
  };
  if (updateAnsweredFormPreviousCall) updateAnsweredFormPreviousCall.cancel(); // cancels previous updateAnsweredForm reqs promises if they're not resolved
  updateAnsweredFormPreviousCall = source;

  return await patch(axios, pathUrl, params, config);
};

export const updateAnsweredFormPatient = async ({ header, params }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${ANSWER}/${PATIENT}`;
  const axios = interceptor(header);
  const source = axiosRef.CancelToken.source();
  const config = {
    cancelRequest: source.cancel,
    cancelToken: source.token,
  };
  if (updateAnsweredFormPreviousCall) updateAnsweredFormPreviousCall.cancel(); // cancels previous updateAnsweredForm reqs promises if they're not resolved
  updateAnsweredFormPreviousCall = source;

  return await patch(axios, pathUrl, params, config);
};

export const putDraft = async ({ header, params }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${DRAFT}`;
  const axios = interceptor(header);
  return await put(axios, pathUrl, params);
};

export const updateFieldMark = async ({ header, params }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${FIELD_MARK}`;
  const axios = interceptor(header);
  return await put(axios, pathUrl, params);
};

export const putFormConfigByPatient = async ({ header, params }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM_CONFIG}/${PATIENT}/${ACCOUNT}`;
  const axios = interceptor(header);
  return await put(axios, pathUrl, params);
};

export const updateStatusFormModelById = async ({ header, params }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${params.formModelId}/${STATUS}`;
  const axios = interceptor(header);
  return await put(axios, pathUrl, params);
};

export const updateStatusDraftById = async ({ header, params }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${DRAFT}/${params.id}/${STATUS}`;
  const axios = interceptor(header);
  return await put(axios, pathUrl, params);
};

export const changeFormModelWorkpaceByAccount = async ({ header, params }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}/${MODEL}/${params.formModelId}/${WORKSPACE}/${ACCOUNT}`;
  const axios = interceptor(header);
  return await put(axios, pathUrl, params);
};

//#endregion

export const deleteForm = async ({ header, formId }) => {
  const pathUrl = `${endpoints.API_FORMS}/${FORM}`;
  const axios = interceptor(header);
  return await del(axios, pathUrl, { formId });
}

export const getFieldsLastVersionByFieldModelIds = async ({ header, params }) => {
  const { fieldModelIds } = params;
  const fieldModelIdsString = fieldModelIds.join(',');
  const pathUrl = `${endpoints.API_FORMS}/field/model/last/versions/batch?fieldModelIds=${fieldModelIdsString}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

//#region FORM BUILDER CHAT
/**
 * @description Cria uma nova sessão de chat com IA para criar formulário
 * @param {Object} header - Headers da requisição
 * @param {String} formName - Nome do formulário
 * @param {String} initialMessage - Mensagem inicial opcional
 * @returns {Promise} Retorna a sessão criada
 */
export const createFormBuilderSession = async ({ header, formName, initialMessage }) => {
  const pathUrl = `${endpoints.API_FORMS}/api/v1/form-builder/sessions`;
  const axios = interceptor(header);
  const params = {
    userId: header?.userId,
    accountId: header?.accountId || header?.account,
    workspaceId: header?.workspaceId || header?.workspace,
    formName,
    ...(initialMessage && { initialMessage })
  };
  return await post(axios, pathUrl, params);
};

/**
 * @description Cria uma nova sessão de chat e envia a primeira mensagem
 * @param {Object} header - Headers da requisição
 * @param {String} sessionId - ID da sessão (opcional, será null na primeira mensagem)
 * @param {String} message - Mensagem a ser enviada
 * @returns {Promise} Retorna sessionId e websocketUrl
 */
export const createSessionBuilderMessage = async ({ header, sessionId, message, draftId }) => {
  const pathUrl = `${endpoints.API_FORMS}/ai/proms/session/create`;
  const axios = interceptor(header);
  const params = {
    sessionId,
    message,
    ...(draftId && { draftId })
  };
  return await post(axios, pathUrl, params);
};

/**
 * @description Envia uma mensagem para uma sessão existente
 * @param {Object} header - Headers da requisição
 * @param {String} sessionId - ID da sessão
 * @param {String} message - Mensagem a ser enviada
 * @returns {Promise} Retorna confirmação do envio
 */
export const sendBuilderMessage = async ({ header, sessionId, message }) => {
  const pathUrl = `${endpoints.API_FORMS}/ai/proms/session/send-message`;
  const axios = interceptor(header);
  const params = {
    message,
    userId: header?.userId,
    accountId: header?.accountId || header?.account,
    sessionId,
  };
  return await post(axios, pathUrl, params);
};

/**
 * @description Finaliza uma sessão de chat e retorna o formulário completo
 * @param {Object} header - Headers da requisição
 * @param {String} sessionId - ID da sessão
 * @returns {Promise} Retorna o formulário finalizado
 */
export const finishFormBuilderSession = async ({ header, sessionId }) => {
  const pathUrl = `${endpoints.API_FORMS}/ai/proms/session/${sessionId}/finalize`;
  const axios = interceptor(header);
  const params = {
    userId: header?.userId,
    accountId: header?.accountId || header?.account
  };
  return await post(axios, pathUrl, params);
};

/**
 * @description Lista sessões de chat
 * @param {Object} header - Headers da requisição
 * @param {String} status - Status das sessões (active, finished)
 * @returns {Promise} Retorna lista de sessões
 */
export const listFormBuilderSessions = async ({ header, status = 'active' }) => {
  const pathUrl = `${endpoints.API_FORMS}/api/v1/form-builder/sessions?status=${status}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

/**
 * @description Obtém detalhes de uma sessão de chat
 * @param {Object} header - Headers da requisição
 * @param {String} sessionId - ID da sessão
 * @returns {Promise} Retorna detalhes da sessão
 */
export const getFormBuilderSession = async ({ header, sessionId }) => {
  const pathUrl = `${endpoints.API_FORMS}/api/v1/form-builder/sessions/${sessionId}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};
//#endregion

//#region [PROM REQUESTS]
export const getPromRequests = async ({ header }) => {
  const pathUrl = `${endpoints.API_FORMS}/ai/prom-requests`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const getPromRequestById = async ({ header, requestId }) => {
  const pathUrl = `${endpoints.API_FORMS}/ai/prom-requests/${requestId}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const createPromRequest = async ({ header, formData }) => {
  const pathUrl = `${endpoints.API_FORMS}/ai/prom-requests`;
  const axios = interceptor({ ...header, 'Content-Type': 'multipart/form-data' });
  return await post(axios, pathUrl, formData);
};

export const reviewPromRequest = async ({ header, requestId, action, comments, draftJson }) => {
  const pathUrl = `${endpoints.API_FORMS}/ai/prom-requests/${requestId}/review`;
  const axios = interceptor(header);
  const params = { action, ...(comments && { comments }), ...(draftJson && { draftJson }) };
  return await put(axios, pathUrl, params);
};

export const approvePromRequest = async ({ header, requestId }) => {
  const pathUrl = `${endpoints.API_FORMS}/ai/prom-requests/${requestId}/approve`;
  const axios = interceptor(header);
  return await post(axios, pathUrl, {});
};

export const rejectPromRequest = async ({ header, requestId, action, comments }) => {
  const pathUrl = `${endpoints.API_FORMS}/ai/prom-requests/${requestId}/reject`;
  const axios = interceptor(header);
  const params = { action, ...(comments && { comments }) };
  return await post(axios, pathUrl, params);
};

export const getPromRequestForm = async ({ header, formId }) => {
  const pathUrl = `${endpoints.API_FORMS}/ai/prom-request-forms/${formId}`;
  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const updatePromRequestForm = async ({ header, formId, draft }) => {
  const pathUrl = `${endpoints.API_FORMS}/ai/prom-request-forms/${formId}`;
  const axios = interceptor(header);
  return await put(axios, pathUrl, { draft });
};
//#endregion